/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * The label position of radio button.
 */
export enum RADIO_BUTTON_LABEL_POSITION {
  /**
   * Placed at left.
   */
  LEFT = 'left',

  /**
   * Placed at right.
   */
  RIGHT = 'right',
}

/**
 * How to lay out radio buttons.
 */
export enum RADIO_BUTTON_ORIENTATION {
  /**
   * Laying out radio buttons horizontally.
   */
  HORIZONTAL = 'horizontal',

  /**
   * Laying out radio buttons vertically.
   */
  VERTICAL = 'vertical',
}
